import React from "react";

export function Info() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z"
        fill="#242424"
      />
      <path
        d="M8.49995 15.6475C12.4474 15.6475 15.6475 12.4474 15.6475 8.49995C15.6475 4.55248 12.4474 1.35242 8.49995 1.35242C4.55248 1.35242 1.35242 4.55248 1.35242 8.49995C1.35242 12.4474 4.55248 15.6475 8.49995 15.6475Z"
        fill="#FFCA28"
      />
      <path
        d="M2.72059 8.50009C2.72059 4.78336 5.55756 1.7296 9.18414 1.38519C8.95893 1.36381 8.73082 1.35242 8.50003 1.35242C4.55251 1.35242 1.35236 4.55253 1.35236 8.50009C1.35236 12.4476 4.55251 15.6478 8.50006 15.6478C8.73085 15.6478 8.95896 15.6364 9.18418 15.615C5.5576 15.2706 2.72059 12.2168 2.72059 8.50009Z"
        fill="#E6B624"
      />
      <path
        d="M9.34177 6.42175H7.6582V13.3131H9.34177V6.42175Z"
        fill="#242424"
      />
      <path
        d="M9.34177 3.68701H7.6582V5.26695H9.34177V3.68701Z"
        fill="#242424"
      />
    </svg>
  );
}
